import type { ApexOptions } from 'apexcharts'
import type { EventsTimeSeriesData } from '../../../features/engagement/domain/models/events'
import { buildStackedBarChartOptions, EventsChartColors, type ChartSeriesItem } from '../charts'

export interface EventsLegendState {
  [key: string]: boolean
  buyNowClicks: boolean
  presaleCodes: boolean
  meetAndGreet: boolean
  vip: boolean
  rsvp: boolean
}

export interface EventsLegendItem {
  key: string
  label: string
  color: string
}

export const EVENTS_LEGEND_ITEMS: EventsLegendItem[] = [
  { key: 'buyNowClicks', label: 'Buy Now Clicks', color: EventsChartColors.buyNowClicks },
  { key: 'presaleCodes', label: 'Presale Codes', color: EventsChartColors.presaleCodes },
  { key: 'meetAndGreet', label: 'Meet & Greet', color: EventsChartColors.meetAndGreet },
  { key: 'vip', label: 'VIP', color: EventsChartColors.vip },
  { key: 'rsvp', label: 'Early Access', color: EventsChartColors.rsvp }
]

export const EVENTS_INITIAL_LEGEND_STATE: EventsLegendState = {
  buyNowClicks: true,
  presaleCodes: true,
  meetAndGreet: true,
  vip: true,
  rsvp: true
}

export const getEventsChartOptions = (data: EventsTimeSeriesData[], legend: EventsLegendState): ApexOptions => {
  const categories = data.map((d) => d.label)

  const series: ChartSeriesItem[] = []

  if (legend.buyNowClicks) {
    series.push({
      name: 'Buy Now Clicks',
      data: data.map((d) => d.buyNowClicks),
      color: EventsChartColors.buyNowClicks
    })
  }

  if (legend.presaleCodes) {
    series.push({
      name: 'Presale Codes',
      data: data.map((d) => d.presaleCodes),
      color: EventsChartColors.presaleCodes
    })
  }

  if (legend.meetAndGreet) {
    series.push({
      name: 'Meet & Greet',
      data: data.map((d) => d.meetAndGreet),
      color: EventsChartColors.meetAndGreet
    })
  }

  if (legend.vip) {
    series.push({
      name: 'VIP',
      data: data.map((d) => d.vip),
      color: EventsChartColors.vip
    })
  }

  if (legend.rsvp) {
    series.push({
      name: 'Early Access',
      data: data.map((d) => d.rsvp),
      color: EventsChartColors.rsvp
    })
  }

  return buildStackedBarChartOptions({
    series,
    categories,
    xAxisLabelFormatter: (value) => value
  })
}
